import { render, staticRenderFns } from "./router.vue?vue&type=template&id=5782d946&scoped=true&"
import script from "./router.ts?vue&type=script&lang=ts&"
export * from "./router.ts?vue&type=script&lang=ts&"
import style0 from "./router.scss?vue&type=style&index=0&id=5782d946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5782d946",
  null
  
)

export default component.exports